import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const pickListAPI = {
	getCurrentUserData: () => {
		return axios.get(`${apiUrl}/users/current`)
			.then(response => response.data as UserDetails);
	},
	linkUserAndAuthRecords: (userId: number) => {
		return axios.post(`${apiUrl}/users/${userId}/linktob2c`, {});
	}
};

export default pickListAPI;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/authAPI.ts